import React from 'react';
import { Frame } from '../Frame';
import Spinner from '@atlaskit/spinner';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { SpinnerWrapper } from './styled';
import { IconTitleWrapper, RightIconPositionWrapper } from '../IconAndTitleLayout/styled';
export class MediaInlineCardLoadingView extends React.Component {
  render() {
    const {
      message,
      onClick,
      isSelected,
      inlinePreloaderStyle,
      testId = 'media-inline-card-loading-view'
    } = this.props;

    if (inlinePreloaderStyle === 'on-right-without-skeleton') {
      return /*#__PURE__*/React.createElement(Frame, {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected
      }, /*#__PURE__*/React.createElement(IconTitleWrapper, null, message, /*#__PURE__*/React.createElement(RightIconPositionWrapper, null, /*#__PURE__*/React.createElement(SpinnerWrapper, {
        className: "inline-loading-spinner"
      }, /*#__PURE__*/React.createElement(Spinner, {
        size: 14
      })))));
    } else {
      return /*#__PURE__*/React.createElement(Frame, {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected
      }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
        title: message
      }, /*#__PURE__*/React.createElement(SpinnerWrapper, {
        className: "inline-loading-spinner"
      }, /*#__PURE__*/React.createElement(Spinner, {
        size: 14
      }))));
    }
  }

}